import React, { FC } from 'react';

import { Radio } from 'antd';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { IChallengeCheckoutProduct } from 'src/shared/models';

interface OwnProps {
  product: IChallengeCheckoutProduct;
  selected: boolean;
}
const ProductItem: FC<OwnProps> = ({
  product,
  selected = false,
}): JSX.Element => {
  const { id, idResource, stock, img, lead } = product;
  const { formatMessage } = useIntl();

  const noStock = stock === 0;
  const cardClassName = classNames('rounded-card checkout-card', {
    'rounded-card--selected': selected,
  });

  return (
    <Radio.Button
      id={id}
      disabled={noStock}
      key={id}
      value={idResource}
      className="item__container"
    >
      <div className={cardClassName} key={id}>
        {noStock && (
          <span className="item__wrapper--no-stock-label">
            {formatMessage({ id: 'page.experience.checkout.no-stock' })}
          </span>
        )}
        <div className="item__wrapper">
          <img
            loading="lazy"
            src={img}
            className="item__wrapper--image"
            alt="event_image"
          />
          <div className="item__wrapper--text">{lead}</div>
        </div>
      </div>
    </Radio.Button>
  );
};

export default ProductItem;
